import theme from 'theme'

type CallToActionBannerProps = {
  fullBorder?: boolean
  disableHover?: boolean
}

const CallToActionBanner: React.FC<CallToActionBannerProps> = ({
  fullBorder,
  disableHover,
  ...rest
}) => {
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: theme.space[7],
          paddingTop: theme.space[3],
          paddingRight: theme.space[3],
          paddingBottom: theme.space[3],
          paddingLeft: theme.space[3],
          backgroundColor: 'white',
          fontSize: theme.fontSizes[1],
          lineHeight: '18px',
          fontWeight: theme.fontWeights[0],
          textAlign: 'center',
          color: theme.colors.steel[2],
          boxShadow: `inset 0 -1px 0 0 ${theme.colors.gray[1]}`
        },
        fullBorder && {
          border: theme.border.base,
          boxShadow: 'none',
          borderRadius: theme.borderRadius[0]
        },
        !disableHover && {
          '&:hover': {
            backgroundColor: 'rgba(216,232,255,0.3)',
            cursor: 'pointer'
          }
        }
      ]}
      role="button"
      {...rest}
    />
  )
}

export default CallToActionBanner
